/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import AccurateSearch from "accurate-search";

import { IModelSpec } from "src/shared/IModelSpec";

/**
 * Model provider
 */
export class ModelProvider {

	/**
	 * List of registered models
	 */
	private models: Array<IModelSpec> = [];

	/**
	 * Index of ID -> Model
	 */
	private index: { [ID: string]: IModelSpec } = {};

	/**
	 * Search index
	 */
	private searchIndex: AccurateSearch;

	/**
	 * Provider constructor
	 */
	public constructor() {

		this.searchIndex = new AccurateSearch();

	}

	/**
	 * Registers a model
	 *
	 * @param spec Model spec
	 */
	public register(spec: IModelSpec) {

		if (this.index[spec.id]) {
			throw new Error(`Model with ID ${spec.id} is already registered.`);
		}

		this.models.push(spec);
		this.index[spec.id] = spec;

		this.searchIndex.addText(spec.id, spec.title + " " + spec.description + " " + spec.version);

	}

	/**
	 * Returns a model spec by ID (or null if not found)
	 *
	 * @param id Model ID
	 */
	public getById(id: string) {

		return this.index[id] || null;

	}

	/**
	 * Returns a list of models
	 *
	 * @param search Optional full-text search
	 */
	public getList(search: string = "") {

		let res: Array<IModelSpec>;

		if (search !== "") {

			res = [];
			const ids = this.searchIndex.search(search);

			for (let i = 0; i < ids.length; i++) {
				res.push(this.index[ids[i]]);
			}

		} else {

			res = this.models.slice();
			res.sort((a, b) =>
				a.title > b.title ? 1 : a.title < b.title ? -1 : a.description > b.description ? 1 : a.description < b.description ? -1 : 0
			);

		}

		return res;

	}

}
